import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  services : [],
  subService : null,
  service : null,
  subServices : [],
  error : null
};


export const SUB_SERVICE_URL = "/admin/sub_service";

export const createSubService = createAsyncThunk(
    SUB_SERVICE_URL + "/create",
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.post(SUB_SERVICE_URL, formData);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

export const getServices = createAsyncThunk(
  SUB_SERVICE_URL + "/get-services",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(SUB_SERVICE_URL + "/services", {
        params : formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getSubServices = createAsyncThunk(
  SUB_SERVICE_URL + "/get-sub-services",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(SUB_SERVICE_URL, {
        params : formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const updateServiceQty = createAsyncThunk(
    "/admin/services/re-stock",
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.post('/admin/services/re-stock', formData);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

const subServiceSlice = createSlice({
    name : "subService",
    initialState,
    extraReducers : (builder) => {
        builder
            .addCase(createSubService.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createSubService.fulfilled, (state, action) => {
                state.isLoading = false;
                state.subService = action.payload?.data;
            })
            .addCase(createSubService.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(getServices.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(getServices.fulfilled, (state, action) => {
                state.isLoading = false;
                state.services = action.payload?.data;
            })
            .addCase(getServices.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(getSubServices.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(getSubServices.fulfilled, (state, action) => {
                state.isLoading = false;
                state.subServices = action.payload?.data;
            })
            .addCase(getSubServices.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

             .addCase(updateServiceQty.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(updateServiceQty.fulfilled, (state, action) => {
                state.isLoading = false;
                state.service = action.payload?.data;
            })
            .addCase(updateServiceQty.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(logout, () => initialState)
    }
})

export default subServiceSlice.reducer